import React from 'react';
import { Col, Modal, OverlayTrigger, Pagination, Row, Tooltip } from 'react-bootstrap';
import '../datalasticShipCompanies/datalastic.scss'
import '../../../common/components/pagination/Pagination.scss';
import { Text } from '../../../common/components/text/Text';
import { Space } from '../../../common/components/space/Space';
import { Main } from '../../../common/components/main/Main';
import { Button } from '../../../common/components/button/Button';
import Card from '../../../common/components/card/Card';
import { Grid } from '../../../common/components/grid/Grid';
import { Table } from '../../../common/components/table/Table';
import Icons from '../../../common/components/icon/Icon';
import { format, parseISO } from 'date-fns'
import {
  datashipEngineListGetAction,
  datashipEngineSetSelectedAction
} from "../../../store/action/dataShipEngAction";
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { history } from '../../../store';
import { Flex } from '../../../common/components/flex/Flex';
import { ReactNode } from 'react';
import datalasticShipCmpService from '../../../services/datalasticShipCmpService';
import swal from 'sweetalert';
import { InputWithIcon } from '../../../common/components/control/Control';
import ShipCmpFilter from '../pagecontainer/ShipCmpFilter';
import { ShipFilterState } from '../../ship/filter/ShipFilterState'
import ShipView from '../pagecontainer/ShipView'
import Loader from 'react-loader-spinner';
import Filterimg from '../../../assets/images/Filter 2.png';
import sortup from '../../../assets/images/sortup_icon.png';
import sortdown from '../../../assets/images/sortdown_icon.png';
import sortimage from '../../../assets/images/sorting.png';

const DatalasticShipCmpList = (props: any) => {
  const { engines, isLoading, totalElement } = props
  const [displayEngines, setEngines] = React.useState<any>([])
  const [searchInput, setSearchInput] = React.useState(ShipFilterState.shipCmpFilter.serachBoxInputCompany)
  const [showModal, setModal] = React.useState(false)
  const [showShip, shipModal] = React.useState(false)
  const [page, setPage] = React.useState(0)
  const [pagination, setPagination] = React.useState([{}])
  const [searchQuery, setQuery] = React.useState('')
  const [low, setLow] = React.useState(1)
  const [high, setHigh] = React.useState(9)
  const perPage = 9
  var totalPage = Math.ceil(totalElement / 10)
  const [showDelete, setShow] = React.useState(false);
  const [deleteShipCmp, setDeleteShipCmp] = React.useState('')
  const [sort, setSorting] = React.useState({ values: ShipFilterState.shipCmpFilter.type, direction: ShipFilterState.shipCmpFilter.direction })
  const role = localStorage.getItem("role")


  // Used to get type and payload, call action and get list.    
  React.useEffect(() => {
    _getCompanies({ page })
  }, [page])

  // console.log(props, 'props in ships company')
  // Check ships(list) length, add checked false in that array.   
  React.useEffect(() => {
    // console.log("companies "+companies)
    console.log(engines)
    console.log(engines.length)
    if (engines && engines.length > 0) {
      setEngines(() => {
        return engines.map((s: any) => ({ ...s, checked: false }))
      })
      console.log(displayEngines, 'engines list in shipEngine')
    }
    if (engines && engines.length === 0) {
      setEngines([])
      console.log(displayEngines, 'engines list in shipEngine')
    }
    
  }, [engines])

  // Get totalPage in props and push into the pagination variable.    
  React.useEffect(() => {
    if (localStorage.getItem(searchInput) != null || localStorage.getItem(searchInput) != '') {
      const user = localStorage.getItem(searchInput) != null ? localStorage.getItem('user') : '';
      ShipFilterState.datalasticshipCmpFilter.serachBoxInputCompany = user != null ? user : '';
    }
    const arrayPage = Array.from(Array(totalPage).keys())
    setPagination(arrayPage)
  }, [totalPage])

  const _getCompanies = (params: any) => {
    console.log(displayEngines, 'engines list in shipEngine')
    if (localStorage.getItem("searchInput") != null || localStorage.getItem("searchInput") != '') {
      const user = localStorage.getItem("searchInput") != null ? localStorage.getItem("searchInput") : '';
      ShipFilterState.datalasticshipCmpFilter.serachBoxInputCompany = user != null ? user : '';
      setSearchInput(user != null ? user : '')
      props.datashipEngineListGetAction({
        page, size: 10,
        status: ShipFilterState.datalasticshipCmpFilter.shipcmpstatus,
        country: ShipFilterState.datalasticshipCmpFilter.shipcmpcountry,
        // shipcmpcountryNames:ShipFilterState.datalasticshipCmpFilter.shipcmpcountryNames,
        city: ShipFilterState.datalasticshipCmpFilter.city,
        companyname: user,
        type: ShipFilterState.datalasticshipCmpFilter.type,
        direction: ShipFilterState.datalasticshipCmpFilter.direction
      })
    } else {
      props.datashipEngineListGetAction({
        page, size: 10,
        status: ShipFilterState.datalasticshipCmpFilter.shipcmpstatus,
        country: ShipFilterState.datalasticshipCmpFilter.shipcmpcountry,
        // shipcmpcountryNames:ShipFilterState.datalasticshipCmpFilter.shipcmpcountryNames,
        city: ShipFilterState.datalasticshipCmpFilter.city,
        companyname: ShipFilterState.datalasticshipCmpFilter.cmpName || searchInput || ShipFilterState.datalasticshipCmpFilter.serachBoxInputCompany,
        type: ShipFilterState.datalasticshipCmpFilter.type,
        direction: ShipFilterState.datalasticshipCmpFilter.direction
      })
    }

    // console.log('success')
  }

  const _willImport = () => {
    history.push('/import/shipEngine')
  }

  //Search Function

  const _shipcmpSearchFuntion = (value: string) => {
    setSearchInput(value)
    localStorage.setItem("searchInput", value)
    ShipFilterState.datalasticshipCmpFilter.serachBoxInputCompany = value
    props.datashipEngineListGetAction({
      page, size: 10,
      status: ShipFilterState.datalasticshipCmpFilter.shipcmpstatus,
      country: ShipFilterState.datalasticshipCmpFilter.shipcmpcountry,
      // shipcmpcountryNames:ShipFilterState.datalasticshipCmpFilter.shipcmpcountryNames,
      city: ShipFilterState.datalasticshipCmpFilter.city,
      companyname: value || ShipFilterState.datalasticshipCmpFilter.cmpName,
      type: ShipFilterState.datalasticshipCmpFilter.type,
      direction: ShipFilterState.datalasticshipCmpFilter.direction
    })
    setPage(0)
    // setLow(1)
    // setHigh(10)
  }

  //Show all

  const _showAllShipeng = () => {
    props.datashipEngineListGetAction({ page, size: 10 })
    setSearchInput('')
    ShipFilterState.datalasticshipCmpFilter.shipcmpstatus = ''
    ShipFilterState.datalasticshipCmpFilter.shipcmpcountry = ''
    ShipFilterState.datalasticshipCmpFilter.shipcmpcountryNames = ''
    ShipFilterState.datalasticshipCmpFilter.city = ''
    ShipFilterState.datalasticshipCmpFilter.cmpName = ''
    ShipFilterState.datalasticshipCmpFilter.page = 0
    ShipFilterState.datalasticshipCmpFilter.size = 10
    ShipFilterState.datalasticshipCmpFilter.serachBoxInputCompany = ''
    localStorage.removeItem("searchInput")
    setSorting({ values: '', direction: '' })
  }

  //will colose modal function

  const _willCloseModal = () => {
    setModal(false)
  }

  //will show filter modal
  const _willShipengFilter = () => {
    setModal(true)
  }

  //will show ship detail modal
  const _willviewShip = (ship: any) => {
    props.datashipEngineSetSelectedAction(ship)
    shipModal(true)
  }

  //close ship Modal

  const _willCloseShip = () => {
    shipModal(false)
  }

  // Redirect to ship detail page.   
  const _willViewDetail = (ship: any) => {
    props.datashipEngineSetSelectedAction(ship)
    history.push(`/ship-companies/${ship.company_id}`)
  }

  //Redirect to ship edit page.   
  const _willViewEdit = (ship: any) => {
    props.datashipEngineSetSelectedAction(ship)
    history.push(`/ship-companies/edit/${ship.company_id}`)
  }

  // Delete the pericular list.   
  const handleClose = () => setShow(false);
  const handleShow = (shipcmp: any) => {
    setShow(true);
    setDeleteShipCmp(shipcmp.company_id)
    // console.log(deleteShipCmp, 'deleted anode id')
  }

  const _willDelete = () => {
    // console.log(deleteShipCmp, 'deleted anode id')
    _deleteShipCmp(deleteShipCmp)
  }

  const _deleteShipCmp = (id: any) => {
    return datalasticShipCmpService.datalasticdeleteShipCompany(id).subscribe({
      next: (r) => {
        // console.log(r, 'response')
        setShow(false)
        swal("Great", " Deleted Successfully", "success")
        props.datashipEngineListGetAction({ company_type: 'SHIP', page, size: 10 })
      },
      error: err => {
        setShow(false)
        swal("OOPS", String(err), "error")
      }
    })
  }

  // Prints first page pagination.   
  const firstPage = () => {
    if (page >= 1) {
      return <Pagination.First onClick={() => _goToFirstPage()}>First</Pagination.First>
    }
  }

  // While click the last page its move to last page.   
  const _goToLastPage = () => {
    setPage(totalPage - 1)
    setHigh(totalPage - 1)
    setLow(totalPage - 9)
  }

  // While click the first button its move to first page.   
  const _goToFirstPage = () => {
    setPage(0)
    setHigh(9)
    setLow(1)
  }

  // Prints last page pagination button.   
  const lastPage = () => {
    if (page !== totalPage - 1) {
      if (page <= high) {
        return <Pagination.Last onClick={() => _goToLastPage()}>Last</Pagination.Last>
      }
    }
  }

  // Prints prev button.   
  const prevBtn = () => {
    if (page >= 1) {
      if (page + 1 === low) {
        setHigh(high - perPage)
        setLow(low - perPage)
      }
      return <Pagination.Prev onClick={() => _goPrevPage()}>Prev</Pagination.Prev>
    }
  }

  // While click prev button go to the previous page of current page.   
  const _goPrevPage = () => {
    setPage(prev => {
      const newValue = prev - 1
      return newValue
    })
  }

  // Print next button.   
  const nextBtn = () => {
    if (page < totalPage - 1) {
      if (page <= high) {
        return <Pagination.Prev onClick={() => _goNextPage()}>Next</Pagination.Prev>
      }
      else {
        setHigh(high + perPage)
        setLow(low + perPage)
      }
    }
  }

  // While click next page button go to the next page of the current page.   
  const _goNextPage = () => {
    setPage(prev => {
      const newValue = prev + 1
      return newValue
    })
  }

  // While click one page number its move to that page.   
  const _goToPage = (page: any) => {
    setPage(page)
  }

  // Return the page number
  const ListItem = (page: any) => {
    return page.value + 1
  }

  // Prints the totalpages between prev, next button.   
  const PageNumber = pagination.map((p, i) => {
    var pagination_num: ReactNode;
    if ((p === 0 && page === 0)) {
      pagination_num = <Pagination.Item onClick={() => _goToPage(p)} active={p === page} key={i}><ListItem value={p} /></Pagination.Item>
    }
    else if ((p < high + 1) && (p >= low - 1)) {
      pagination_num = <Pagination.Item onClick={() => _goToPage(p)} active={p === page} key={i}><ListItem value={p} /></Pagination.Item>
    }
    return (
      pagination_num
    )
  })

  const sortByFieldn = (value: String, directions: String) => {
    if (directions === 'asc') {
      setSorting({ values: String(value), direction: String(directions) });
      ShipFilterState.datalasticshipCmpFilter.type = String(value);
      ShipFilterState.datalasticshipCmpFilter.direction = String(directions);
      props.datashipEngineListGetAction({
        page, size: 10,
        status: ShipFilterState.datalasticshipCmpFilter.shipcmpstatus,
        country: ShipFilterState.datalasticshipCmpFilter.shipcmpcountry,
        // shipcmpcountryNames:ShipFilterState.datalasticshipCmpFilter.shipcmpcountryNames,
        city: ShipFilterState.datalasticshipCmpFilter.city,
        companyname: ShipFilterState.datalasticshipCmpFilter.cmpName,
        type: value,
        direction: directions

      })
      setPage(0)

    }
    else if (directions === 'desc') {
      setSorting({ values: String(value), direction: String(directions) });
      ShipFilterState.datalasticshipCmpFilter.type = String(value);
      ShipFilterState.datalasticshipCmpFilter.direction = String(directions);
      props.datashipEngineListGetAction({
        page, size: 10,
        status: ShipFilterState.datalasticshipCmpFilter.shipcmpstatus,
        country: ShipFilterState.datalasticshipCmpFilter.shipcmpcountry,
        // shipcmpcountryNames:ShipFilterState.datalasticshipCmpFilter.shipcmpcountryNames,
        city: ShipFilterState.datalasticshipCmpFilter.city,
        companyname: ShipFilterState.datalasticshipCmpFilter.cmpName,
        type: value,
        direction: directions
      })
      setPage(0)

    }
    else if (directions === '') {
      setSorting({ values: String(value), direction: String(directions) });
      ShipFilterState.datalasticshipCmpFilter.type = String(value);
      ShipFilterState.datalasticshipCmpFilter.direction = String(directions);
      props.datashipEngineListGetAction({
        page, size: 10,
        status: ShipFilterState.datalasticshipCmpFilter.shipcmpstatus,
        country: ShipFilterState.datalasticshipCmpFilter.shipcmpcountry,
        // shipcmpcountryNames:ShipFilterState.datalasticshipCmpFilter.shipcmpcountryNames,
        city: ShipFilterState.datalasticshipCmpFilter.city,
        companyname: ShipFilterState.datalasticshipCmpFilter.cmpName,
        type: value,
        direction: directions
      })
      setPage(0)
    }
  };


  return (
    <Main>
      <Text variant="title" color='black'>Ship Engine List</Text>
      <Space divheight={15} />
      <Card>
        <SearchForm>
          <Row className='m-0 p-0'>
            {/* <Col xs='12' sm='12' md='12' lg='4' xl='4' className='m-0 p-0'>
              <div className='mr-3 mb-2 mb-sm-2 mb-md-2 mb-lg-0 mb-xl-0'>
                <Row className='m-0 p-0'>
                  <Col xs='12' sm='10' md='9' lg='12' xl='12' className='m-0 p-0'>
                    <InputWithIcon
                      type="text"
                      value={searchInput}
                      onChange={(e) => _shipcmpSearchFuntion(e.target.value)}
                      placeholder="Search by Company Name.."
                      icon="search"
                      id="search-input"
                    />
                  </Col>
                </Row>
              </div>
            </Col> */}
            <Col xs='12' sm='12' md='12' lg='8' xl='8' className='m-0 p-0'>
              <div className='search-btn-container'>
                {/* <div className='search-btn-add'>
                  {role === 'VISITOR' ? (
                    //   <Link to='/ships-company/add'>    Button add new ship, if you click the button it shows modal box.  
                    <Button variant='transparent' block={true} disabled>
                      <Icons color="#ffffff" icon="add" />
                      ADD NEW COMPANY
                    </Button>
                    //  </Link>
                  ) : (<Link to='/ships-company/add'>    Button add new ship, if you click the button it shows modal box.   
                    <Button variant='transparent' block={true}>
                      <Icons color="#ffffff" icon="add" />
                      ADD NEW COMPANY
                    </Button>
                  </Link>)}
                </div> */}
                <div className='search-btn-add'>
                  {role === 'VISITOR' ? (
                    //   <Link to='/ships-company/add'>   {/* Button add new ship, if you click the button it shows modal box.    */}
                    <Button variant='transparent' className='ml-1' onClick={() => _willImport()} disabled>
                      Import
                    </Button>
                    //  </Link>
                  ) : (
                    /* Button add new ship, if you click the button it shows modal box.    */
                    <Button variant='transparent' className='ml-1' onClick={() => _willImport()}>
                      Import
                    </Button>
                  )}
                </div>
                {/* <div className='search-btn-filter'>
                  <Button className='link_button filter' onClick={() => _willShipengFilter()}>
                    <img src={Filterimg} alt='filterimg' />
                  </Button>
                </div>
                <div className='search-btn-showall'>
                  <Button variant='transparent' block={true} onClick={() => _showAllShipeng()}>
                    Show All
                  </Button>
                </div> */}
              </div>
            </Col>
          </Row>
        </SearchForm>
        <Space divheight={30} />
        {
          isLoading && <Text center>
            <Loader
              type="Rings"
              color="#233269"
              height={100}
              width={100}
              timeout={30000}
            />
          </Text>
        } {/* Check the list is loading, isloading is true its shows loading text.   */}
        {
          !isLoading && displayEngines.length === 0 && (
            <>
              <Space divheight={20} />
              <Text center>No ship Engine found</Text>
              <Space divheight={20} />
            </>
          )
        } {/* If isloading is false and also the list array length is 0 its shows no discount fount text.    */}
        {
          !isLoading && displayEngines.length > 0 && (
            <>
              <Table>
                <thead>
                  <tr key={0}>
                    <th>S.No</th>
                    <th>Name</th>
                    <th>Imo Number</th>
                    <th>Year Built</th>
                    <th>Engine Builder</th>
                    <th>Engine Designation</th>
                    <th>Engine Designer</th>
                    <th>GRT</th>
                    <th>MCO</th>
                    <th>MCO RPM</th>
                    <th>MCO Unit</th>
                    <th>Propulsion Type</th>
                    <th>Ship Type</th>
                    <th>Trading Category</th>
                  </tr>
                </thead>
                <tbody>
                  {/* Map the list array and display the datas in a table.    */}
                  {displayEngines.map((data: any, i: any) => (
                    <tr key={data.id}>
                      <td data-label='S.No'>
                        {page === 0 && (
                          i + 1
                        )}
                        {page >= 1 && (
                          (page * 10) + (i + 1)
                        )}
                      </td>
                     
                      <td data-label='Vessel Name'>{data.vessel_name === null ? (
                        <Text variant='subtitle'> - </Text>
                      ) : (
                        <Text variant='subtitle'>{data.vessel_name}</Text>
                      )}
                      </td>

                      <td data-label='Imo Number'>{data.imo_number === null ? (
                        <Text variant='subtitle'> - </Text>
                      ) : (
                        <Text variant='subtitle'>{data.imo_number}</Text>
                      )}
                      </td>

                      <td data-label='Year Built'>{data.year_built === null ? (
                        <Text variant='subtitle'> - </Text>
                      ) : (
                        <Text variant='subtitle'>{data.year_built}</Text>
                      )}
                      </td>
              
                      <td data-label='Engine Builder'>{data.engine_builder === null ? (
                        <Text variant='subtitle'> - </Text>
                      ) : (
                        <Text variant='subtitle'>{data.engine_builder}</Text>
                      )}
                      </td>

                      <td data-label='Engine Designation'>{data.engine_designation === null ? (
                        <Text variant='subtitle'> - </Text>
                      ) : (
                        <Text variant='subtitle'>{data.engine_designation}</Text>
                      )}
                      </td>

                      <td data-label='Engine Designer'>{data.engine_designer === null ? (
                        <Text variant='subtitle'> - </Text>
                      ) : (
                        <Text variant='subtitle'>{data.engine_designer}</Text>
                      )}
                      </td>

                      <td data-label='GRT'>{data.grt === null ? (
                        <Text variant='subtitle'> - </Text>
                      ) : (
                        <Text variant='subtitle'>{data.grt}</Text>
                      )}
                      </td>

                      <td data-label='MCO'>{data.mco === null ? (
                        <Text variant='subtitle'> - </Text>
                      ) : (
                        <Text variant='subtitle'>{data.mco}</Text>
                      )}
                      </td>

                      <td data-label='MCO RPM'>{data.mco_rpm === null ? (
                        <Text variant='subtitle'> - </Text>
                      ) : (
                        <Text variant='subtitle'>{data.mco_rpm}</Text>
                      )}
                      </td>

                      <td data-label='MCO UNIT'>{data.mco_unit === null ? (
                        <Text variant='subtitle'> - </Text>
                      ) : (
                        <Text variant='subtitle'>{data.mco_unit}</Text>
                      )}
                      </td>

                      <td data-label='Propulsion Type'>{data.propulsion_type === null ? (
                        <Text variant='subtitle'> - </Text>
                      ) : (
                        <Text variant='subtitle'>{data.propulsion_type}</Text>
                      )}
                      </td>

                      <td data-label='Ship Type'>{data.ship_type === null ? (
                        <Text variant='subtitle'> - </Text>
                      ) : (
                        <Text variant='subtitle'>{data.ship_type}</Text>
                      )}
                      </td>

                      <td data-label='Trading Category'>{data.trading_category_code === null ? (
                        <Text variant='subtitle'> - </Text>
                      ) : (
                        <Text variant='subtitle'>{data.trading_category_code}</Text>
                      )}
                      </td>
                     
                    </tr>
                  ))}
                </tbody>
              </Table>
              <TableFooter>
                <Text> {/* Display the total elements.   */}
                  {displayEngines.length === 1 && (
                    <>
                      <b>
                        {displayEngines.length}
                        {/* {((page) * 10) + 1} - {(displayCompanies.length + (page) * 10)} */}
                      </b> of {totalElement} Engine
                    </>
                  )}
                  {displayEngines.length > 1 && (
                    <>
                      <b>
                        {displayEngines.length}
                        {/* {((page) * 10) + 1} - {(displayCompanies.length + (page) * 10)} */}
                      </b> of {totalElement} Engine
                    </>
                  )}
                </Text>
                <Pagination size="sm">
                  {firstPage()} {/* First page button.    */}
                  {prevBtn()} {/* Previous button.    */}
                  {PageNumber} {/* Totalpages.    */}
                  {nextBtn()} {/* Next button.    */}
                  {lastPage()} {/* Last page button.    */}
                </Pagination>
              </TableFooter>
            </>
          )
        }
      </Card >
      {/* If modal is true goto the Modal box page with the props of onclose function */}
      {showModal && <ShipCmpFilter onClose={() => _willCloseModal()} />}
      {showShip && <ShipView onClose={() => _willCloseShip()} />}


      <Modal show={showDelete} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <Text variant='title-sm' color='main' bold>
              Confirmation
            </Text>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Text bold variant='confirmation' color='danger' values='Permanently you want to delete this item form ship Companies list' />
        </Modal.Body>
        <Modal.Footer>
          <Button variant='transparent' onClick={handleClose}>
            <Icons icon="close" />
            Close
          </Button>
          <Button variant='transparent' onClick={() => _willDelete()}>
            <Icons icon="delete_forever" />
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </Main >
  )
}
export interface TablefooterProps {
  children?: React.ReactNode
}

// Table footer style.   
const TableFooter = (props: TablefooterProps) => {

  const tablefooter = classNames('tablefooter')

  return (
    <Flex jc='jc-between' className={tablefooter}>
      {props.children}
    </Flex>
  )

}

export interface TableActionsProps {
  children?: React.ReactNode
}

// Table body style.   
const TableActions = (props: TableActionsProps) => {

  const tableAction = classNames('tableAction')

  return (
    <Flex jc='jc-center' className={tableAction}>
      {props.children}
    </Flex>
  )

}

interface searchProps {
  children?: React.ReactNode
}

//Search Form Component  for displaying serarch box, and add ship button
const SearchForm = (props: searchProps) => {

  const search = classNames('serachForm')
  return (
    <form autoComplete='off' className={search}>
      {props.children}
    </form>
  )
}

// Connect to the action and get the list, totalpage and total elements.   
const mapStateToProps = (state: any) => ({
  engines: state.datalasticShipEng.dataLasticEngines,
  isLoading: state.datalasticShipEng.isLoading,
  error: state.datalasticShipEng.error,
  totalPage: state.datalasticShipEng.totalPage,
  totalElement: state.datalasticShipEng.totalElement
})

export default connect(
  mapStateToProps,
  {
    datashipEngineListGetAction,
    datashipEngineSetSelectedAction
  }
)(DatalasticShipCmpList)